import React from 'react';
import PropTypes from 'prop-types';

const DebugBlock = ({ touched, values, initialValues, debug }) => {
  if (debug)
    return (
      <div className="debug-block">
        <span>Values:</span>
        <pre>
          <code style={{ display: 'block', padding: '0.5em', backgroundColor: '#eee' }}>
            {JSON.stringify(values, null, 2)}
          </code>
        </pre>
        <span>Touched:</span>
        <code style={{ display: 'block', padding: '0.5em', backgroundColor: '#eee' }}>{JSON.stringify(touched)}</code>
        <span>InitialValues:</span>
        <code style={{ display: 'block', padding: '0.5em', backgroundColor: '#eee' }}>
          {JSON.stringify(initialValues)}
        </code>
      </div>
    );
  return '';
};

DebugBlock.propTypes = {
  touched: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  values: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  initialValues: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
  debug: PropTypes.bool.isRequired,
};

DebugBlock.defaultProps = {};

export default DebugBlock;
